import React from "react";

import { IconLoading } from "../icons";

interface ChatLoadingStateProps {
  message: string;
}

/**
 * A simple loading state component showing a spinner and message.
 * Used while loading user profile or workflow data.
 */
export const ChatLoadingState: React.FC<ChatLoadingStateProps> = ({ message }) => {
  return (
    <div className="flex h-full w-full" role="status">
      <div className="w-full h-full pl-2 pr-2">
        <div aria-live="polite" className="flex flex-col items-center justify-center h-full">
          <IconLoading />
          <p className="mt-4 text-primary">{message}</p>
        </div>
      </div>
    </div>
  );
};
